import { connect } from "react-redux";

import ForecastsFiltersContainer from "../components/forecasts_filters_container";

const mapStateToProps = (state) => {
  return {
    selectedBook: state.filters.reportBook
  };
};

const mapDispatchToProps = () => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ForecastsFiltersContainer);
